import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'
import { useThemeMode } from '../../partials/layout/theme-mode/ThemeModeProvider'

const Content: FC<WithChildren> = ({children}) => {
  const location = useLocation()
  const {mode} = useThemeMode()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_content_container' className={clsx('content flex-row-fluid',)} style={{backgroundColor: 'transparent'}} data-bs-theme={mode}>
      {children}
    </div>
  )
}

export {Content}
